@for (modal of modals; track modal) {
  <dcp-default-modal [modalId]="modal.id"></dcp-default-modal>
}
